module.exports = __webpack_public_path__ + "img/tianjin.07623c72.jpg";